import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'

export const DEFAULT_POSITION = -1

export const getHasNoSuggestions = (
  categoryList = [],
  modifierValueList = []
) => !isArrayWithLength(categoryList) && !isArrayWithLength(modifierValueList)
